import { FC } from "react";
import "./stepper.scss";

interface SimpleStepperProps {
  steps: string[];
  onClick?: (index: number) => void;
  selectedStep?: number;
}

const SimpleStepper: FC<SimpleStepperProps> = ({
  onClick,
  selectedStep,
  steps,
}) => {
  return (
    <div className="stepper-wrapper">
      {(steps ?? []).map((step, index) => {
        return (
          <div
            className={`stepper-item ${
              index === selectedStep ? "completed active" : ""
            }`}
            key={index}
            onClick={() => onClick?.(index)}
          >
            <div
              className={`step-counter ${
                index === selectedStep ? "shadow-sm" : ""
              }`}
            >
              &nbsp;
            </div>
            <div className="step-name">{step}</div>
          </div>
        );
      })}
    </div>
  );
};

export default SimpleStepper;
